/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../components/ServicesLayout';
import Panel from './Panel';
import UserInfo from '../userInfo/UserInfo';
import MojeDokumenty from '../mojeDokumenty/MojeDokumenty';
import DeleteAccount from '../DeleteAccount/index.js';
import ConfirmDelete from '../ConfirmDelete/index.js';
import ConfirmAccount from '../ConfirmAccount/index.js';
import MyMessages from '../MyMessages/index.js';
import MessageDetail from '../MessageDetail/index.js';
import StatusGmin from '../StatusGmin/StatusGmin.jsx';
import Statystyka from '../Statystyka/Statystyka.jsx';
import RODO_CONTENT from '../../components/utils/rodo';
import ZestawieniaGminne from '../ZestawieniaGminne/ZestawieniaGminne.jsx';
import NotFound from '../notFound/NotFound.js';

const title = 'Panel użytkownika';
const notLoggedTitle = 'Panel niedostępny - nie zalogowano do portalu.'
const notLoggedMessage = <div style={{ textAlign: 'center' }}>
    <p>Twoja sesja wygasła. Zaloguj się ponownie do portalu swojej gminy.</p>
    <a
      href={'/urzad'}
      className="btn btn-primary"
    >
      <b>Wyszukaj gminę</b>
    </a>
  </div>;

export default {
  path: '/panel',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return { redirect: `/panel/${state.user.username}` };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="moje_dane">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username',
      async action(ctx, a, b) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="moje_dane" sidePanel>
                <UserInfo userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="moje_dane">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/mojedokumenty',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="dokumenty" sidePanel>
                <MojeDokumenty userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="dokumenty">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/usunkonto',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="usun_konto" sidePanel>
                <DeleteAccount userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="usun_konto">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/usun-konto/:token',
      async action(ctx) {
        const state = await ctx.store.getState();

        return {
          title,
          component: (
            <ServicesLayout active_panel="potwierdz">
              <ConfirmDelete
                userData={state.user ? state.user : null}
                token={ctx.params.token}
              />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/aktywuj-konto/:token',
      async action(ctx) {
        const state = await ctx.store.getState();

        return {
          title,
          component: (
            <ServicesLayout active_panel="aktywuj_konto">
              <ConfirmAccount
                userData={state.user ? state.user : null}
                token={ctx.params.token}
              />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/mojezapytania',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="moje_zapytania" sidePanel>
                <MyMessages userData={state.user} login={ctx.params.username} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="moje_zapytania">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/rodo',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="rodo" sidePanel>
                <div style={{ marginTop: '50px', marginRight: '50px' }}>
                  <RODO_CONTENT/>
                </div>
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="rodo">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/statusgmin',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="status_gmin" sidePanel>
                <StatusGmin userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="status_gmin">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/statystyka',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="statystyka" sidePanel>
                <Statystyka userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="statystyka">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
    path: '/:username/zestawienia',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="zestawienia_gminne" sidePanel>
                <ZestawieniaGminne userData={state.user} />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="zestawienia_gminne">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
    {
      path: '/:username/zapytanie/:id',
      async action(ctx) {
        const state = await ctx.store.getState();
        if (state.user) {
          return {
            title,
            component: (
              <ServicesLayout active_panel="zapytanie" sidePanel>
                <MessageDetail
                  userData={state.user}
                  login={ctx.params.username}
                  id={ctx.params.id}
                />
              </ServicesLayout>
            ),
          };
        }
        return {
          title: notLoggedTitle,
          component: (
            <ServicesLayout active_panel="zapytanie">
              <NotFound title={''} message={notLoggedMessage} />
            </ServicesLayout>
          ),
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/panel/index.js